import { initializeGlobalAugmentation } from '@gat-ship/utils'
import { createApp } from 'vue'
import App from './App.vue'
import { registerGlobalComponents } from './plugins/app-components'
import {
  registerPlugins,
  registerGlobalProperties
} from './plugins/app-plugins'
import { handleGlobalErrors } from './utils/global-error-handler'

// Initialize global augmentations for String.prototype and Array.prototype methods
initializeGlobalAugmentation()
const app = createApp(App)

registerPlugins(app)
registerGlobalProperties(app)
registerGlobalComponents(app)
handleGlobalErrors(app)

app.mount('#app')
